import { View } from "react-native";
import { ActivityIndicator } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

export default function LoadingView() {
  const tailwind = useTailwind();
  return (
    <View style={tailwind("flex-1 items-center justify-center")}>
      <ActivityIndicator size={48} />
    </View>
  );
}
